var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 5.889H0A7.715 7.715 0 0 1 3.2 0h26.61s.01 0 .01.01A7.736 7.736 0 0 1 33 5.89Z",
    fill: "#046FBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.485 2.94c-.173 4.118 1.1 14.97 1.1 14.97.592 5.401-2.618 7.72-6.053 7.72 0 0-2.69-.05-3.496.285C18.243 26.688 17.57 28 16.561 28H16.46c-1.009 0-1.681-1.312-3.475-2.085-.805-.346-3.496-.285-3.496-.285-3.434 0-6.634-2.308-6.054-7.72 0 0 1.285-10.852 1.101-14.97C4.413.345 3.72.07 3.261.01V0H29.74v.01c-.459.061-1.142.336-1.254 2.93Z",
    fill: "#19A4F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 27.522c-.357 0-.714-.295-1.203-.702-.52-.427-1.162-.956-2.09-1.353-.642-.274-2.13-.335-3.271-.335h-.418c-1.722 0-3.22-.61-4.21-1.72-1.13-1.26-1.6-3.152-1.355-5.46.051-.438 1.285-10.934 1.111-15.043-.05-1.089-.193-1.892-.448-2.441h23.899c-.265.549-.408 1.352-.448 2.44-.174 4.11 1.05 14.606 1.11 15.043.255 2.309-.214 4.2-1.355 5.462-.999 1.108-2.497 1.719-4.21 1.719h-.417c-1.141 0-2.64.06-3.271.335-.928.397-1.57.926-2.09 1.353-.489.407-.846.702-1.202.702h-.132Z",
    fill: "url(#text_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.175 9.425-2.912-2.912A1.751 1.751 0 0 0 18.025 6h-5.837a.875.875 0 0 0-.876.875v12.25c0 .483.393.875.876.875h9.624a.876.876 0 0 0 .875-.875v-8.463c0-.463-.184-.91-.512-1.237ZM18.75 7.237l2.7 2.7h-1.825a.876.876 0 0 1-.875-.874V7.236Zm-5.243 5.442c0-.06.05-.11.11-.11h6.78c.06 0 .11.05.11.11v.656c0 .06-.05.11-.11.11h-6.78a.11.11 0 0 1-.11-.11v-.656Zm.007 4.368c0-.06.049-.11.109-.11h6.781c.06 0 .11.05.11.11v.656c0 .06-.05.11-.11.11h-6.781a.11.11 0 0 1-.11-.11v-.656Zm7-1.518c0 .06-.05.11-.11.11h-6.781a.11.11 0 0 1-.11-.11v-.656c0-.06.05-.11.11-.11h6.781c.06 0 .11.05.11.11v.656Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text_svg__a",
    x1: 16.502,
    y1: -6.155,
    x2: 16.502,
    y2: 6.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgText;